import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class ButtonMixin extends Vue {
  @Prop() size!: string
  @Prop({ default: false }) showLoader!: boolean

  private isClicked = false

  private onClick() {
    this.isClicked = true

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur()
    }
  }

  get isPending() {
    return this.showLoader
  }
}
